import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { EmployerLayoutComponent } from './employer-layout/employer-layout.component';
import { LayoutHeaderComponent } from './employer-layout/layout-header/layout-header.component';
import { LayoutSidebarComponent } from './employer-layout/layout-sidebar/layout-sidebar.component';
import { UserService } from '../core/services/v2/user.service';
import { AuthService } from '../auth/auth.service';
import { LoginGuard } from '../auth/loginGuard';
import { EmployerRoutingModule } from './employer-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbCollapseModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../material/material-module';
import { LightboxModule } from 'ngx-lightbox';
import { CoreModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { EmployerDashboardComponent } from './employer-dashboard/employer-dashboard.component';
import { EmployeesComponent } from './employees/employees.component';
import { EmployerAdminToolComponent } from './employer-admin-tool/employer-admin-tool.component';
import { EmployersComponent } from './employers/employers.component';
import { NgxMaskModule } from 'ngx-mask';
import { EmployerPaymentMethodComponent } from './employer-payment-method/employer-payment-method.component';
import { EmployerPaymentHistoryComponent } from './employer-payment-history/employer-payment-history.component';
import { EmployerProfileComponent } from './employer-profile/employer-profile.component';
import { EmployerFindCareComponent } from './employer-find-care/employer-find-care.component';
import { PlanCoverageComponent } from './plan-coverage/plan-coverage.component';
import { EmployerSubscriptionsComponent } from './employer-subscriptions/employer-subscriptions.component';
import { EmployerCheckoutComponent } from './employer-checkout/employer-checkout.component';
import { EmployerChoosePlansComponent } from './employer-choose-plans/employer-choose-plans.component';
import { EmployerActivePlansComponent } from './employer-active-plans/employer-active-plans.component';
import { EmployerAgencyProfileComponent } from './employer-agency-profile/employer-agency-profile.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EmployerCheckoutCreditcardComponent } from './employer-checkout-creditcard/employer-checkout-creditcard.component';
import { EmployerPlanDetailsComponent } from './employer-plan-details/employer-plan-details.component';
import { EmployerTeldacplanComponent } from './employer-teldacplan/employer-teldacplan.component';
import { EmployerTeldacFaqplanComponent } from './employer-teldac-faqplan/employer-teldac-faqplan.component';
import { EmployerHealthadvocatePlanComponent } from './employer-healthadvocate-plan/employer-healthadvocate-plan.component';
import { EmployerHealthadvocatefaqPlanComponent } from './employer-healthadvocatefaq-plan/employer-healthadvocatefaq-plan.component';
import { EmployerNbfitnessPlanComponent } from './employer-nbfitness-plan/employer-nbfitness-plan.component';
import { EmployerNbrxPlanComponent } from './employer-nbrx-plan/employer-nbrx-plan.component';
import { EmployerLabtestingPlanComponent } from './employer-labtesting-plan/employer-labtesting-plan.component';
import { EmployerNbdealsPlanComponent } from './employer-nbdeals-plan/employer-nbdeals-plan.component';
import { EmployerNbtravelPlanComponent } from './employer-nbtravel-plan/employer-nbtravel-plan.component';
import { EmployerPetrxPlanComponent } from './employer-petrx-plan/employer-petrx-plan.component';
import { EmployerSponsoredPlanComponent } from './employer-sponsored-plan/employer-sponsored-plan.component';
import { EmployerdManifestrxPlanComponent } from './employerd-manifestrx-plan/employerd-manifestrx-plan.component';
import { EmployerdLifelockessentialPlanComponent } from './employerd-lifelockessential-plan/employerd-lifelockessential-plan.component';
import { CompanyProfileComponent } from './company-profile/company-profile.component';
import { CompanyProfilePageComponent } from './company-profile-page/company-profile-page.component';
import { AddEmployeeCheckoutComponent } from './add-employee-checkout/add-employee-checkout.component';
import { HsaFsaPopupComponent } from './hsa-fsa-popup/hsa-fsa-popup.component';
import { SelectedMultiplePlanComponent } from './selected-multiple-plan/selected-multiple-plan.component';
import { EmployeeActiveProgramCheckoutComponent } from './employee-active-program-checkout/employee-active-program-checkout.component';
import { MyEmployeesSubscriptionComponent } from './my-employees-subscription/my-employees-subscription.component';
import { EmployerSettingsComponent } from './employer-settings/employer-settings.component';

@NgModule({
  declarations: [
    EmployerLayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    EmployerDashboardComponent,
    EmployeesComponent,
    EmployerAdminToolComponent,
    EmployersComponent,
    EmployerPaymentMethodComponent,
    EmployerPaymentHistoryComponent,
    // EmployerProfileComponent,
    EmployerFindCareComponent,
    PlanCoverageComponent,
    // EmployerSubscriptionsComponent,
    EmployerCheckoutComponent,
    EmployerChoosePlansComponent,
    EmployerActivePlansComponent,
    EmployerAgencyProfileComponent,
    EmployerCheckoutCreditcardComponent,
    EmployerPlanDetailsComponent,
    EmployerTeldacplanComponent,
    EmployerTeldacFaqplanComponent,
    EmployerHealthadvocatePlanComponent,
    EmployerHealthadvocatefaqPlanComponent,
    EmployerNbfitnessPlanComponent,
    EmployerNbrxPlanComponent,
    EmployerLabtestingPlanComponent,
    EmployerNbdealsPlanComponent,
    EmployerNbtravelPlanComponent,
    EmployerPetrxPlanComponent,
    EmployerSponsoredPlanComponent,
    EmployerdManifestrxPlanComponent,
    EmployerdLifelockessentialPlanComponent,
    CompanyProfileComponent,
    CompanyProfilePageComponent,
    AddEmployeeCheckoutComponent,
    HsaFsaPopupComponent,
    SelectedMultiplePlanComponent,
    EmployeeActiveProgramCheckoutComponent,
    MyEmployeesSubscriptionComponent,
    EmployerSettingsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    EmployerRoutingModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    LightboxModule,
    MatDialogModule,
    MatButtonModule,
    CoreModule,
    SharedModule,
    MatSnackBarModule,
    NgxMaskModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    UserService,
    AuthService,
    LoginGuard,
    DatePipe,
  ],
  entryComponents: [
    EmployerAgencyProfileComponent,
    HsaFsaPopupComponent
  ],
  bootstrap: [EmployerLayoutComponent]
})
export class EmployerModule { }
